// 화면이 바라보는 지역. 다른 지역으로 바꿀 때는 아래 import 경로 두 줄만 교체한다.
//
// CRA(webpack)는 정적 import 만 번들에 넣으므로 경로에 변수를 쓸 수 없다.
// 대신 catalog.json·locations.json은 여기서 import 하지 않는다. 카탈로그는 화면에
// 필요 없고, locations.json은 개발 중 핀을 저장할 때마다 바뀐다. 메뉴가 그 파일을
// 직접 구독하면 좌표 하나를 저장할 때마다 React 전체가 다시 로드된다.
import meta from './regions/goheung/region.json';
import menuData from './regions/goheung/menu.json';

export const region = meta;
export const locations = menuData.locations;
